export default "__VITE_ASSET__DVIYNMyk__"